import React, { useState, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { excluir } from '../../../../util/AcessoApi'
import { Visualizar, Excluir, BtnAcao } from '../../../../components/Acoes'
import { mensagens } from '../../../../util/Utilitarios.js'
import { mostrarToast } from '../../../../components/Toasts'
import { validarAcessoPreAnestesico } from '../../../../util/FuncoesComuns'

const Consulta = props => {
    const [data, setData] = useState([])
    const target = useRef(null)

    const columns = React.useMemo(
        () => [{
            id: 'consulta-pos-anestesico',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                },
                {
                    Header: 'Guia',
                    accessor: 'guia_id',
                    visivel: true,
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'Identificação',
                    accessor: 'cpf',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Paciente',
                    accessor: 'beneficiario',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'beneficiario',
                        idColuna: 'questionario_paciente.beneficiario_id'
                    }
                },
                {
                    Header: 'Operadora Saúde',
                    accessor: 'operadora_saude',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'operadora_saude',
                        idColuna: 'questionario_paciente.operadora_saude_id'
                    }
                },
                {
                    Header: 'Estabelecimento Saúde',
                    accessor: 'estabelecimento_saude',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'estabelecimento_saude',
                        idColuna: 'questionario_paciente.estabelecimento_saude_id'
                    }
                },
                {
                    Header: 'Sócio',
                    accessor: 'socio',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'socio',
                        idColuna: 'questionario_paciente.socio_id'
                    }
                },
                {
                    Header: 'Data Procedimento',
                    accessor: 'data_procedimento',
                    visivel: true,
                    ordenamento: {
                        tipo: 'data'
                    }
                },
                {
                    Header: 'Data Registro',
                    accessor: 'data_registro',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    )

    const alteracao = async (propsAcao) => {
        validarAcessoPreAnestesico(() => {
            window.open('/posanestesico/consultaposanestesico/alteracao/' + propsAcao.row.id, '_blank');
        }, () => {
            mostrarToast('erro', "A ação não é permitida: O usuário logado não está associado ao sócio que efetuou a consulta");
        }, propsAcao.row.id, '/posanestesico/validarAcesso')
    }

    const exclusao = async (propsAcao) => {
        excluir('/posanestesico/consultaposanestesico', propsAcao.row.id,
            () => {
                target.current.atualizar();
                mostrarToast('sucesso', mensagens['sucesso'])
            },
            (e) => {
                if (e.response && e.response.data && e.response.data.erros)
                    e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                else
                    mostrarToast('erro', mensagens.erro)
            }, propsAcao.row.descricao_auditoria)
    }

    const acoesObj = [
        (propsAcao) => <Visualizar to={'/posanestesico/consultaposanestesico/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <BtnAcao icone="icon-Pen" texto="Alterar" action={() => alteracao(propsAcao)} />,
        (propsAcao) => <Excluir to={'/posanestesico/consultaposanestesico/consulta/'} action={() => exclusao(propsAcao)} />,
    ]

    return (
        <>
            <div>
                <DataGridAlternativa acoesObj={acoesObj} removerTotalPaginas data={data} columns={columns} setData={setData} acoes={true} target={target} caminhoBase='/posanestesico/consultaposanestesico' caminhoConsultaFiltros='/posanestesico/consultaposanestesicoPaginacao' modulo={props.modulo} titulo={'Indicadores Pós-Anestésico'}
                    tituloLista={'Lista de Indicadores Assistenciais'} icone={'icon-Tablet'} posAnestesico={true} />
            </div>
        </>
    )
}

export default Consulta
